import { useTranslation } from 'react-i18next';

interface BookingStepperProps {
  step: 'when' | 'details' | 'done';
}

export function BookingStepper({ step }: BookingStepperProps) {
  const { t } = useTranslation();

  if (step === 'done') {
    return null;
  }

  return (
    <div className="booking-stepper" aria-label="Booking steps">
      <div className={`booking-stepper-step ${step === 'when' ? 'is-active' : 'is-done'}`}>
        <span className="booking-stepper-dot">1</span>
        <span className="booking-stepper-label">{t('booking.step.when')}</span>
      </div>
      <div className="booking-stepper-line" />
      <div className={`booking-stepper-step ${step === 'details' ? 'is-active' : ''}`}>
        <span className="booking-stepper-dot">2</span>
        <span className="booking-stepper-label">{t('booking.step.details')}</span>
      </div>
    </div>
  );
}
